<template>
    <div>
        <div v-if="!configurations.length" class="rounded-lg border bg-white p-6 text-sm text-gray-500 shadow-sm">
            {{ trans('subscription.notifications.pm_empty') }}
        </div>

        <div v-for="config in configurations" :key="config.config_id" class="mb-6 overflow-hidden rounded-lg border bg-white shadow-sm">
            <div class="border-b bg-gray-50 px-4 py-3">
                <h4 class="font-semibold">{{ config.title }}</h4>
                <p class="text-xs text-gray-400">
                    {{ trans('subscription.notifications.pm_assets', { count: config.asset_count }) }} ·
                    {{ trans('subscription.notifications.pm_recipients', { count: config.recipients.length }) }}
                </p>
                <div v-if="config.assets.length" class="mt-2 flex flex-wrap gap-1.5">
                    <Link
                        v-for="asset in config.assets"
                        :key="asset.id"
                        :href="route('assets.show', asset.id)"
                        class="rounded-full border bg-white px-2 py-0.5 text-xs text-primary hover:bg-gray-50"
                    >
                        {{ asset.label }}
                    </Link>
                </div>
            </div>

            <div v-if="!config.recipients.length" class="px-4 py-3 text-sm text-gray-500">
                {{ trans('subscription.notifications.pm_no_recipients') }}
            </div>

            <ul v-else class="divide-y">
                <li v-for="(recipient, index) in config.recipients" :key="index" class="px-4 py-3">
                    <div class="flex items-center gap-2">
                        <span class="font-medium">{{ recipient.name }}</span>
                        <span class="rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-600 capitalize">{{ recipient.type }}</span>
                        <span v-if="recipient.eligible === false" class="rounded-full bg-amber-100 px-2 py-0.5 text-xs text-amber-700">
                            {{ trans('subscription.notifications.recipient_ineligible') }}
                        </span>
                    </div>

                    <div v-for="group in recipient.groups" :key="group.id" class="ms-3 mt-2 border-s ps-3">
                        <div class="text-xs font-semibold text-gray-500">{{ group.name }}</div>
                        <ul class="mt-1 space-y-0.5">
                            <li v-for="channel in group.channels" :key="channel.id" class="text-sm text-gray-700">
                                {{ channel.label || channel.destination }}
                                <span v-if="channel.label" class="text-xs text-gray-400"> · {{ channel.destination }}</span>
                            </li>
                        </ul>
                    </div>

                    <ul v-if="recipient.channels.length" class="ms-3 mt-2 space-y-0.5">
                        <li v-for="channel in recipient.channels" :key="channel.id" class="text-sm text-gray-700">
                            {{ channel.label || channel.destination }}
                            <span v-if="channel.label" class="text-xs text-gray-400"> · {{ channel.destination }}</span>
                        </li>
                    </ul>

                    <div v-if="!recipient.groups.length && !recipient.channels.length" class="ms-3 mt-1 text-sm text-gray-400">
                        {{ trans('subscription.notifications.no_channels') }}
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
import { Link } from '@inertiajs/vue3';
import { trans } from '@/mixins/i18n';

defineProps({
    configurations: { type: Array, default: () => [] },
});
</script>
